require("babel-polyfill");
require('nodelist-foreach-polyfill');

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');

require('bootstrap');
window.nipplejs = require('nipplejs');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.Cookies = require('js-cookie');
window.Swal = require('sweetalert2');

if ((screen.width >= screen.height && screen.width <= 768)
    || (screen.width < screen.height && screen.height <= 768)) {
    $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0">');
}

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if (window.location.hostname !== '') {
    axios.defaults.baseURL = `${window.location.protocol}//api.${window.location.hostname}`;
} else {
    axios.defaults.baseURL = 'https://api.app.robokids.online';
}

window.Cookies.defaults.expires = 365 * 10;

window.setAppStorage = (key, value) => {
    if (window.location.hostname !== '') {
        window.Cookies.set(key, value);
    } else {
        window.localStorage.setItem(key, value);
    }
};

window.getAppStorage = (key) => {
    let result = null;

    if (window.location.hostname !== '') {
        result = window.Cookies.get(key);
    } else {
        result = window.localStorage.getItem(key);
    }

    return result;
};

window.removeAppStorage = (key) => {
    if (window.location.hostname !== '') {
        window.Cookies.remove(key);
    } else {
        window.localStorage.removeItem(key);
    }
};

window.moment = require('moment');
window.objectToFormData = require('object-to-formdata');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });



// WEBPACK FOOTER //
// ./src/bootstrap.js